<app-splash-screen></app-splash-screen>
<app-authorized-layout *ngIf="isLoggedIn && isUserDetailsFetch">
  <router-outlet></router-outlet>
  <app-loader></app-loader>
</app-authorized-layout>

<p-toast [baseZIndex]="5000" position="top-right" [preventOpenDuplicates]="true" [breakpoints]="constants.toasterResponsive.toaster"></p-toast>
